import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@redux/reducers';

export interface Notification {
    type: 'warning' | 'success' | 'error' | 'loading';
    title: string;
    notificationKey?: string;
    message: string;
    callback?: (...args) => void;
}

interface INotificationState {
    notifications: Notification[];
}

const initialState: INotificationState = {
    notifications: [],
};

const draftsSlice = createSlice({
    name: 'notificationsSlice',
    initialState,
    reducers: {
        addNotification: (state, action: PayloadAction<Notification>) => {
            state.notifications = [...state.notifications, action.payload];
            return state;
        },
        removeNotification: (state, action: PayloadAction<Notification>) => {

            state.notifications = state.notifications.filter(
                (n) => {
                    if(!action.payload.notificationKey){
                        return n.title !== action.payload.title
                    }
                    return n.title !== action.payload.title && n.notificationKey !== action.payload.notificationKey 
                }
            );

            return state;
        },
        clearState: (state) => {
            state.notifications = []

            return state;
        },
    },
});

export const notificationsSelector = (state: RootState): Notification[] =>
    state.notification.notifications;

export const { addNotification, removeNotification, clearState } = draftsSlice.actions;

export default draftsSlice.reducer;
